module.exports = __webpack_public_path__ + "img/Checkmark-pink.e52bd935.svg";